import { call, put, takeLatest } from "redux-saga/effects";
import {
  INSERT_ORDER_REQUEST,
  INSERT_ORDER_SUCCESS,
  INSERT_ORDER_FAILURE
} from "./paymentType";
import { insertOrderSuccess, insertOrderFailure } from "./paymentActions";
import axiosInstance from "../instance/AxiosInstance";
function* insertOrderSaga(action) {
  try {
    const response = yield call(
      axiosInstance.get,
      `/ccavenue/getorderdetails?order_id=${action.payload}`
    );
    console.log("response", response);
    yield put(insertOrderSuccess(response.data));
  } catch (error) {
    yield put(insertOrderFailure(error.message));
  }
}
export function* watchInsertOrder() {
  yield takeLatest(INSERT_ORDER_REQUEST, insertOrderSaga);
}
